import { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import stripe from '../../../utilities/stripe';
import { Text } from '@chakra-ui/react';
import { postData, deleteData } from '../../../utilities/axios';
import { useSelector } from 'react-redux';
import PaymentForm from './PaymentForm';

const stripePromise = stripe();

const ManagePayment = ({
  practitionerType,
  paymentType,
  intentCache,
  onLoad,
  redirect,
  type,
}) => {
  const [intent, setIntent] = useState(intentCache);
  const token = useSelector((state) => state.user.JWTToken);

  useEffect(() => {
    if (!paymentType || intentCache !== null) {
      return;
    }

    const data = {
      type: paymentType,
      practitionerType,
      redirectUrl: redirect,
    };
    async function fetchData() {
      const res = await postData(
        token,
        data,
        `${process.env.NEXT_PUBLIC_NEW_PAYMENT_URL}${type}`
      );

      setIntent(res.clientSecret);
      onLoad(res.clientSecret);
      if (type === 'subscription') {
        window.location.replace(res.url);
      }
    }
    fetchData();
  }, [intentCache, onLoad, paymentType, practitionerType, redirect, token, type]);

  return intent ? (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret: intent,
      }}
    >
      <PaymentForm redirect={redirect} />
    </Elements>
  ) : (
    <Text>Loading...</Text>
  );
};

export default ManagePayment;
